import React, { useState, useEffect } from "react";
import {
  TablePagination,
  Typography,
} from "@material-ui/core";
import { useRouteMatch } from "react-router-dom";
import { getProfilePosition, getFilterProfiles } from "../../actions/position-actions";
import { getMaestras } from "../../actions/maestras-actions";
import Search from "../../images/icons/search.svg";
import { useStateValue } from "../../context/store";
import PositionSearch from "./positionSearch";
import TablePosition from "./tablePosition";
//import { makeStyles } from "@material-ui/core/styles";
import { permissionsConstans } from '../../constansPermissions'
import { headers } from "./dataPosition";
import _ from 'lodash';

/* const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
})); */


/* const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  button: {
    color: "blue",
    background: "#e7f103",
    "&:hover": { color: "white", background: "#0f70b7" },
    marginTop: "2%",
  },

  bootstrapFormLabel: {
    fontSize: 18,

    marginLeft: "1%",
    marginRight: "1%",
  },

  message: {
    textAlign: "center",
    padding: "100px",
    fontSize: "20px",
  },
})); */

export default function SearchRegional(props) {
  //const [open, setOpen] = useState(false);
  const [location, setLocation] = useState([]);
  const [charges, setCharges] = useState([]);
  const [{filterProfile}, dispatch] = useStateValue();
  const [data, setData] = useState({
    rolePosition: null,
    nameProfilePosition: null,
    immediateBoss: null,
    location: null,
    chargeMission: null,
    status: null,
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });
  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });
  const [maestras, setMaestras] = useState({
    jefeInmediato: [],
    rolDecargo: [],
  });


  const { path } = useRouteMatch();
  //const ver = (id) => alert(id);
  const editar = (id) => {
    const rutaEditar = props.history.push(`${path}/editar/${id}`);
    /* if(rutaEditar){
      breadCrumb.open 
    } */
    return rutaEditar;
  }
  //const anular = (id) => setOpen(true);


  const getReqs = async () => {
    const response = await getFilterProfiles(
      {
        rolePosition: data.rolePosition === "" ? null : data.rolePosition,
        nameProfilePosition: data.nameProfilePosition === "" ? null : data.nameProfilePosition,
        immediateBoss: data.immediateBoss === "" ? null : data.immediateBoss,
        location:data.location === "" ? null : data.location,
        chargeMission: data.chargeMission === "" ? null : data.chargeMission,
        status: data.status === "" ? null : data.status, 
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response?.data) {
      const data = response?.data?.profileResponsePage;
      if (data?.content?.length > 0) {
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data?.size,
          pageNumber: data?.number,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  if (
    filterProfile &&
    filterProfile?.isFilter &&
    data !== filterProfile.filter
  ) {
    const newfilter = filterProfile.filter;
    data.rolePosition = newfilter.rolePosition;
    data.nameProfilePosition = newfilter.nameProfilePosition;
    data.immediateBoss = newfilter.immediateBoss;
    data.location = newfilter.location;
    data.chargeMission = newfilter.chargeMission;
    data.status = newfilter.status;
    paginadorRequest.page = 0;
    getReqs();
    dispatch({
      type: "SET_FILTER",
      isFilter: false,
    });
  }

  const validationPermissionPathCreate = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'PER_CAR')
 
   if(module?.functionalities?.some((x)=> x === permissionsConstans.PER_CAR_CREAR)){
    return  "/dashboard/perfil-cargos/crear"
   } else {
    return null
   }
    
  }

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListaMaestras();

    const getListaLocations = async () => {
      const response = await getMaestras();
      setLocation(response?.data?.maestras?.ubicaciones);
    };
    getListaLocations();

    const getListaRegionalStatus = async () => {
      const response = await getProfilePosition("ACTIVO");
      setCharges(response?.data?.chargeList);
    };
    getListaRegionalStatus();

    getReqs();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Cargos   |   Cargos  >  Perfil de Cargos",
      breadCrumbSubText: "Perfil de Cargos",
      index: 6,
      path: validationPermissionPathCreate(),
    });
    
  }, [paginadorRequest]);

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'PER_CAR')
 
    if(module?.functionalities?.some((x)=> x === permissionsConstans.PER_CAR_CONSULTAR)){
     return   <PositionSearch
                currentData={data}
                currentMaestras={maestras}
                currentLocation={location}
                currentCharges={charges}
              />
   }
  }
  

  return (
    <div>
      {validationPermission()}

      {paginadorResponse.data.map((row, index) => (
        <TablePosition
          headers={headers}
          data={row}
          onEdit={editar}
          // onView={verRequisicion}
          // onDelete={anularRequisicionConfirm}
        />
      ))}
       {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage='Registros por página'
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
}
